import { Box } from '@amzn/awsui-components-core';
import React from 'react';

export const TableQueryErrorInfo = (props: { errorMessage: string }) => {
  if (props.errorMessage === 'TOO_MANY_RESULTS') {
    return (
      <Box textAlign="center" margin={{ vertical: 's' }}>
        <b>Too many results</b>
        <Box variant="p" margin={{ bottom: 'xs' }}>
          Query result exceeds 500 results. Please refine query conditions.
        </Box>
      </Box>
    );
  }

  return (
    <Box textAlign="center" margin={{ vertical: 's' }}>
      <b>Error updating results</b>
      <Box variant="p" padding={{ bottom: 'xs' }}>
        Please try again or submit issue.
      </Box>
    </Box>
  );
};
